module.exports = __webpack_public_path__ + "img/exercises.e1325097.svg";